import { companiesCompanyIdEmailSelfServeConfigurationData } from "@dashboardApi/apis/companiesCompanyIdEmailSelfServeConfigurationData";

import type { AllRouteEndpoints } from "../routeTypes";

// Refetched rather than patched: adding IP addresses changes server-computed fields (status,
// availableIps) as well as the pool itself.
export const postCompaniesCompanyIdEmailSelfServeIpAddressesCacheKeys: AllRouteEndpoints[] = [
  companiesCompanyIdEmailSelfServeConfigurationData,
];
